import { init, track } from '@amplitude/analytics-browser';
import config from '@/config';
import { getLoggedInUserEmail } from './helpers';

class EventTracker {
  constructor() {
    init(config.amplitudeAnalytics.apiKey);
  }

  static orderLineClick(payLoad: OrderLineClickPayload) {
    const loggedInUserEmail = getLoggedInUserEmail();

    track('orderLineClick', {
      partNumber: payLoad.partNumber,
      customers: payLoad.customer,
      loggedInUserEmail,
    });
  }

  static rfqClick() {
    const loggedInUserEmail = getLoggedInUserEmail();

    track('rfqClick', { loggedInUserEmail });
  }

  static rfqLoad(isSuccess: boolean) {
    const loggedInUserEmail = getLoggedInUserEmail();

    track('rfqLoad', {
      success: isSuccess,
      loggedInUserEmail,
    });
  }

  static rfqView() {
    const loggedInUserEmail = getLoggedInUserEmail();

    track('rfqView', { loggedInUserEmail });
  }

  static saleOrderView() {
    const loggedInUserEmail = getLoggedInUserEmail();

    track('saleOrderView', { loggedInUserEmail });
  }

  static postPrices(saleOrderName: string) {
    const loggedInUserEmail = getLoggedInUserEmail();

    track('postPrices', {
      saleOrderName,
      loggedInUserEmail,
    });
  }

  static cellEdit(saleOrderName: string, partNumber: string, column: string) {
    const loggedInUserEmail = getLoggedInUserEmail();

    track('cellEdit', {
      saleOrderName,
      partNumber,
      column,
      loggedInUserEmail,
    });
  }
}

interface OrderLineClickPayload {
  partNumber?: string | null;
  customer?: string | null;
}

export default EventTracker;
